<template lang="pug">
    .component-card
        .row
            .columns.shrink.align-self-middle(v-if="showBullets")
                slot(name="actionBullets")
            .columns
                .row
                    .columns
                        slot(name="n1")
                    .columns
                        slot(name="n2")
                    .columns
                        slot(name="n3")
                    .columns
                        slot(name="n4")
                    .columns
                        slot(name="n5")
                    .columns
                        slot(name="n6")
                    .columns
                        slot(name="n7")
            .columns.shrink.align-self-middle(v-if="showAction")
                slot(name="actionPage")
</template>
<script type="text/babel">
    export default{
        name: "Card7",
        components: {
        },
        data(){
            return {}
        },
        created() {
        },
        methods: {
            actionClicked(){
                this.$emit('actionClicked')
            },
            bulletsClicked(){
                this.$emit('bulletsClicked')
            }
        },
        computed: {},
        props: ['showBullets', 'showAction']
    }
</script>

<style lang="sass" rel="stylesheet/sass">
    .action
        cursor: pointer
</style>


// WEBPACK FOOTER //
// Tab7.vue?c741f352